import { render, staticRenderFns } from "./BatchDownloadFile.vue?vue&type=template&id=2c9e3a02"
import script from "./BatchDownloadFile.vue?vue&type=script&lang=js"
export * from "./BatchDownloadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports